// extracted by mini-css-extract-plugin
export default {"warning":"CancelShipmentForm_warning__Y5FSw"};